import { render } from "./FilterSalesmanV2.vue?vue&type=template&id=39350f71"
import script from "./FilterSalesmanV2.vue?vue&type=script&lang=js"
export * from "./FilterSalesmanV2.vue?vue&type=script&lang=js"
script.render = render

export default script